



































































































































































































import {namespace} from 'vuex-class'
import {Component, Mixins, Prop} from 'vue-property-decorator'

import {Warning, Bracket, Xmark, Refund} from '@/icons'
import {showChannelTalk} from '@/utils'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import Assets from '@/mixins/Assets'
import {Biz} from '@/store/modules/biz/types'
import {TaxRefund, RefundStatus} from '@/store/modules/taxrefund/types'
import {LogEventWidthGroupsPayload, BizPropertyPayload} from '@/store/modules/gtm/types'

import DialogFooter from '@/components/DialogFooter.vue'
import ChangeBizPopup from '@/components/popup/page/ChangeBiz.vue'
import RegisterCertGuidePopup from '@/components/popup/page/RegisterCertGuide.vue'
import RegisterCertGuidePopupB from '@/components/popup/page/RegisterCertGuideB.vue'
import SelectInvoiceActionPopup from '@/components/popup/btt/SelectInvoiceAction.vue'
import MainMenu from '@/pages/home/MainMenu.vue'
import RefundCard from '@/pages/home/RefundCard.vue'
import Footer from '@/pages/home/Footer.vue'

import RequestNewTokenModal from './sign-up/RequestNewTokenModal.vue'


const auth = namespace('auth')
const institutions = namespace('institutions')
const layout = namespace('layout')
const invoices = namespace('invoices')
const taxes = namespace('taxes')
const gtm = namespace('gtm')
const notice = namespace('notice')
const biz = namespace('biz')
const subsidy = namespace('subsidy')
const taxrefund = namespace('taxrefund')
const certificates = namespace('certificates')

/**
 * @displayName HomePage
 */
@Component({
  components: {
    RequestNewTokenModal,
    DialogFooter,
    ChangeBizPopup,
    RegisterCertGuidePopup,
    SelectInvoiceActionPopup,
    RegisterCertGuidePopupB,
    MainMenu,
    RefundCard,
    Warning,
    Bracket,
    Xmark,
    Refund,
    Footer,
  },
})
export default class HomePage extends Mixins(Translation, PopupHandler, Assets) {
  @Prop({default: 0, type: Number}) windowScrollY: number

  @auth.Action('getUser') getUser
  @auth.State('id') userId
  @institutions.Action('getCertInstitutions') getCertInstitutions
  @institutions.Getter('hometaxStatus') hometaxStatus
  @institutions.Getter('giroStatus') giroStatus
  @institutions.Getter('eiStatus') eiStatus
  @institutions.Getter('gtmInfo') institutionsGtmInfo
  @institutions.State('institutions') institutions
  @layout.Mutation('updateError') updateError
  @invoices.Action('getInvoiceSummary') getInvoiceSummary
  @invoices.State('amountTotal') invoiceAmountTotal
  @invoices.State('count') invoiceCount
  @taxes.Action('getTaxSummary') getTaxSummary
  @taxes.State('amountTotal') taxAmountTotal
  @taxes.State('count') taxCount
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void
  @notice.Getter('homeNotice') homeNotice
  @notice.Action('getNoticeCard') getNoticeCard
  @biz.State('name') bizName: string
  @biz.State('isCorporate') isCorporate: boolean
  @biz.State('bizs') bizs: Biz[]
  @subsidy.Getter('subsidyCount') subsidyCount: number;
  @subsidy.Getter('youthAmount') youthSubsidyAmount: number;
  @subsidy.Action('getSubsidy') getSubsidy: () => Promise<void>
  @taxrefund.Getter('getRefundError') getRefundError
  @taxrefund.Getter('getRefundStatus') getRefundStatus: RefundStatus
  @taxrefund.State('taxrefund') taxrefund?: TaxRefund
  @taxrefund.Action('getTaxRefund') getTaxRefund: () => Promise<void>
  @certificates.State('isRequiredPopup') isRequiredPopup
  @certificates.State('certificates') certificates
  @certificates.Mutation('updateRequiredPopup') updateRequiredPopup
  @certificates.Action('getCertificates') getCertificates

  loading: boolean = true
  redirectSettingPageItem: string = ''
  redirectSettingPage: string = ''
  openErrorDialog: boolean = false
  openRequiredRegCertDialog: boolean = false
  openRequiredReRegCertDialog: boolean = false
  openAnalyzingDialog: boolean = false
  openBeforeConfirmDialog: boolean = false
  openRegisterCertGuidePopup: boolean = false
  openRegisterCertGuidePopupB: boolean = false
  openChangeBizPopup: boolean = false
  errorMessage: string = ''
  showMoreErrorMessages: boolean = false
  bizsWithHasExpiredCertificate: Biz[] = []

  get certCount(): number {
    const certificates = [...this.certificates]
    return certificates.length
  }

  get noticeTitle() {
    return this.homeNotice.title
  }

  get conservativeTaxRefund(): number {
    const {refundPerYear} = this.taxrefund as TaxRefund
    const totalRefundAmount = Math.floor(refundPerYear.reduce((prev, curr) => curr.amount + prev, 0))
    return totalRefundAmount
  }

  closeErrorDialog() {
    this.showMoreErrorMessages = false
    this.openErrorDialog = false
  }

  handleToCs() {
    this.showMoreErrorMessages = false
    this.openErrorDialog = false
    showChannelTalk()
  }

  toggleShowMoreErrorMessages() {
    this.showMoreErrorMessages = !this.showMoreErrorMessages
  }

  onCloseSettingPopup() {
    this.redirectSettingPageItem = ''
    this.redirectSettingPage = ''
  }

  onViewNotice() {
    this.redirectSettingPageItem = this.homeNotice.id
    this.redirectSettingPage = 'notice'
  }

  onViewTax() {
    if(this.giroStatus !== 'success') this.openRequiredRegCertDialog = true
    else {
      this.$router.push({
        name: 'taxes',
      }).catch((err) => err)
    }
  }

  setBizEntity() {
    this.setBizProperty({
      event: 'setBizProperty',
      bizProperty: {
        'biz_entity': this.isCorporate ? 'corporate' : 'private',
      },
    })
  }

  bypassRegisterCert() {
    this.updateRequiredPopup(false)
    this.openRequiredRegCertDialog = false
    this.openRequiredReRegCertDialog = false
  }

  openRegisterCertPopup() {
    this.bypassRegisterCert()
    this.openCertPopup()
  }

  openCertPopup() {
    const nav: any = window.navigator
    if(this.userId % 2 === 0 || !nav.canShare) {
      this.openRegisterCertGuidePopup = true
    } else {
      this.openRegisterCertGuidePopupB = true
    }
  }

  handleHelp() {
    this.openRegisterCertGuidePopupB = false
    this.openRegisterCertGuidePopup = true
  }

  loadCertList() {
    this.getCertificates()
      .then(() => {this.loading = false})
      .catch((error) => {
        this.updateError({
          id: 'get-certificates',
          message: this.ts('error.certificates'),
          action: {
            kind: 'refresh',
          },
        })
        throw error
      })
  }

  loadCertSummary() {
    this.loading = true
    this.getCertInstitutions()
      .then(() => {
        if(this.giroStatus === 'success') {
          this.loadTaxSummary()
        }
        if(this.hometaxStatus === 'success') {
          this.loadInvoiceSummary()
        }
        if(this.eiStatus === 'success') {
          // TODO: 홈화면에 노출해주는 건수와 금액의 경우 별도의 summary API를 통해 호출하고 있음.
          // 해당 건의 경우 우선 지원금 조회 API를 호출하도록 하고, 추후 summary API 타입에 EI를 추가하도록 개발해줄 필요 있음.
          // URL 예: /bizs/397/transactions/summary?kind=tax_pay
          // this.getSubsidy()
        }
        this.setBizProperty({
          event: 'setBizProperty',
          bizProperty: this.institutionsGtmInfo,
        })
      })
      .catch((error) => {
        this.updateError({
          id: 'get-cert-institutions',
          message: this.ts('error.get-cert-institutions'),
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  loadTaxSummary() {
    this.getTaxSummary()
      .catch((error) => {
        this.updateError({
          id: 'get-tax-summary',
          message: this.ts('error.get-tax-summary'),
        })
        throw error
      })
  }

  loadInvoiceSummary() {
    this.getInvoiceSummary()
      .catch((error) => {
        this.updateError({
          id: 'get-invoice-summary',
          message: this.ts('error.get-invoice-summary'),
        })
        throw error
      })
  }

  changeBiz(id: string) {
    this.$router.push({
      name: 'home',
      params: {bizId: id},
    })
      .then(() => {
        this.initData()
        this.loadCertSummary()
      })
      .catch((err) => err)

    this.logEventWithGroups({
      eventType: 'change_biz',
    })
  }

  selectInvoiceAction(action: string) {
    this.$emit('to', action)
  }

  createBiz() {
    this.$router.push({
      name: 'create-biz',
    }).catch((err) => err)
  }

  initData() {
    this.bizsWithHasExpiredCertificate = this.bizs.filter((biz) => biz.hasExpiredCertificate)
    if(this.bizsWithHasExpiredCertificate.length) {
      this.openRequiredReRegCertDialog = true  
    }
    this.loadCertSummary()
    this.loadCertList()
    this.getTaxRefund().then(() => {
      const status = this.getRefundStatus
      if(status === RefundStatus.에러) {
        this.openErrorDialog = true
        const error = this.getRefundError
        this.errorMessage = error.message
      } else {
        this.errorMessage = ''
      }
      if(status === RefundStatus.환급급확인전) {
        this.openBeforeConfirmDialog = true
      }
    })
  }

  mounted() {
    this.initData()
  }

  created() {
    // 외부 제휴사 banner prefill 키가 sign-up-biz/create-biz를 거치지 않고 메인까지
    // 흘러왔다는 것은 더 이상 사용될 일이 없는 stale 값이라는 의미이므로 정리한다.
    // 이미 회사 등록을 마친 사용자가 실수로 banner URL을 열어 localStorage에 잔류하는
    // 케이스를 방어한다. (sign-up-biz / create-biz는 Biz.vue created()에서 정리)
    localStorage.removeItem('company_name')
    localStorage.removeItem('business_number')
    this.openRequiredRegCertDialog = this.isRequiredPopup
    this.getUser()
    this.setBizEntity()
    this.getNoticeCard()
  }
}
